import { AxiosError } from 'axios';

import { IApiError } from '@interfaces';

export interface IApiErrorCreateInterface {
	message?: string;
	status?: number;
	statusText?: string;
	throwable?: Error;
	code?: string;
	serverError?: {
		error: string;
		error_description: string;
		error_uri: string;
	};
	request?: {
		method: string;
		url: string;
		data: string;
	};
}

export class ApiError implements IApiError {

	status: number;
	statusText: string;
	message: string;
	code: string;
	serverError: {
		error: string;
		errorDescription: string;
		errorUri: string;
	};
	request: {
		method: string;
		url: string;
		data: string;
	};
	throwable: Error;

	constructor(props: IApiErrorCreateInterface | AxiosError | ApiError) {
		if (props instanceof ApiError) {
			return props;
		}
		if ((props as AxiosError).request) {
			const axiosProps = props as AxiosError;

			this.code = axiosProps.code;
			this.message = axiosProps.message;
			this.throwable = axiosProps;

			this.request = props.request;

			if (axiosProps.response) {
				this.status = axiosProps.response.status;
				this.statusText = axiosProps.response.statusText;
			} else {
				this.status = null;
				this.statusText = null;
			}

			if (axiosProps.response && axiosProps.response.data != null) {
				this.serverError = {
					error: axiosProps.response.data.error,
					errorDescription: axiosProps.response.data.error_description,
					errorUri: axiosProps.response.data.error_uri,
				};
			} else {
				this.serverError = null;
			}
		} else {
			const customProps = props as IApiErrorCreateInterface;

			this.code = customProps.code;
			this.message = customProps.message;
			this.status = customProps.status;
			this.statusText = customProps.statusText;
			this.throwable = customProps.throwable;

			if (customProps.serverError != null) {
				this.serverError = {
					error: customProps.serverError.error,
					errorDescription: customProps.serverError.error_description,
					errorUri: customProps.serverError.error_uri,
				};
			} else {
				this.serverError = null;
			}
		}
	}

}
